import * as React from "react";
import {LeadGenerationStep} from "./types/lead-generation-step";

export class MyIzenFlowService
{
    getNextStep( currentStep: string, quote: any )
    {
        switch ( currentStep ) {
            case LeadGenerationStep.ORDER_TYPE:
                if ( quote.homeStatus === 'new' ) {
                    return LeadGenerationStep.CONFIRMATION_NEW_CONSTRUCTION;
                }
                return LeadGenerationStep.SOLAR_BATTERY;
            case LeadGenerationStep.SOLAR_BATTERY:
                return LeadGenerationStep.ORDER;
            case LeadGenerationStep.SOLAR:
                return LeadGenerationStep.ORDER;
            case LeadGenerationStep.BATTERY:
                return LeadGenerationStep.ORDER;
            case LeadGenerationStep.ORDER:
                return LeadGenerationStep.ORDER_CONFIRMATION;
            case LeadGenerationStep.CREATE_APPOINTMENT:
                if ( quote.homeStatus === 'new' ) {
                    return LeadGenerationStep.CONFIRMATION_NEW_CONSTRUCTION;
                }
                return LeadGenerationStep.ORDER_CONFIRMATION;
            default:
                return LeadGenerationStep.ORDER_TYPE;
        }
    }
}
